/* src/app/invoice/setup/invoice-session-update-dialog/invoice-session-update-dialog.component.scss */
form ::ng-deep {
  min-width: 25em;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
form ::ng-deep > span.p-float-label {
  padding-bottom: 0.5em;
  width: 100%;
  margin-top: 1.25em;
}
form ::ng-deep > span.p-float-label .p-dropdown,
form ::ng-deep > span.p-float-label .p-inputtext,
form ::ng-deep > span.p-float-label .p-calendar {
  width: 100%;
}
form ::ng-deep > span.p-float-label > p-tristatecheckbox + label,
form ::ng-deep > span.p-float-label > p-checkbox + label {
  top: 0 !important;
}
/*# sourceMappingURL=invoice-session-update-dialog.component.css.map */
